import React from 'react';

interface WarningAlertIconProps {
  fill?: string;
  width?: string | number;
  height?: string | number;
}

export const WarningAlertIcon: React.FC<WarningAlertIconProps> = ({ fill = '#FFAF45', width = 16, height = 16 }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99984 2.66675C10.9454 2.66675 13.3332 5.05456 13.3332 8.00008C13.3332 10.9456 10.9454 13.3334 7.99984 13.3334C5.05432 13.3334 2.6665 10.9456 2.6665 8.00008C2.6665 5.05456 5.05432 2.66675 7.99984 2.66675ZM7.99984 3.50008C5.51456 3.50008 3.49984 5.5148 3.49984 8.00008C3.49984 10.4854 5.51456 12.5001 7.99984 12.5001C10.4851 12.5001 12.4998 10.4854 12.4998 8.00008C12.4998 5.5148 10.4851 3.50008 7.99984 3.50008ZM7.9955 9.85341C8.37684 9.85341 8.68884 10.1654 8.68884 10.5381C8.68884 10.9107 8.37684 11.2314 7.9955 11.2314C7.62284 11.2314 7.31084 10.9107 7.31084 10.5381C7.31084 10.1654 7.62284 9.85341 7.9955 9.85341ZM7.99984 4.66675C8.30856 4.66675 8.55884 4.91702 8.55884 5.22575V8.44108L8.55448 8.5112C8.51999 8.78683 8.28482 9.00008 7.99984 9.00008C7.69111 9.00008 7.44084 8.74981 7.44084 8.44108L7.44084 5.22575L7.44519 5.15563C7.47969 4.88 7.71486 4.66675 7.99984 4.66675Z"
      fill={fill}
    />
  </svg>
);
